import { AccountApiFactory } from './account-api';
import { ReferenceTokenApiFactory } from './reference-token-api';
import { TrustedBrowsersApiFactory } from './trusted-browser-api';
import { BaseAPI } from '@shared/api/base-api';
import { PATH_TO_AUTH_API } from '@shared/constants';

const api = new BaseAPI(PATH_TO_AUTH_API);

export * from './identity-api';
export * from './phone-verification-api';

export { TokenApi } from './token-api';
export const AccountApi = AccountApiFactory();
export const ExternalApiTokenApi = ReferenceTokenApiFactory(api);
export const TrustedBrowsersApi = TrustedBrowsersApiFactory();
